import { useCallback } from "react"
import { ConnectionHandler } from "relay-runtime"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import {
  Ch_saveCarePlanDataInput,
  chSaveCarePlanDataMutation,
  chSaveCarePlanDataMutation$data,
} from "@/modules/patients/services/ch/__generated__/chSaveCarePlanDataMutation.graphql"
import { chSaveCarePlanDataMutation as chMutation } from "@/modules/patients/services/ch/chSaveCarePlanDataMutation"
import {
  De_saveCarePlanDataInput,
  deSaveCarePlanDataMutation,
  deSaveCarePlanDataMutation$data,
} from "@/modules/patients/services/de/__generated__/deSaveCarePlanDataMutation.graphql"
import { deSaveCarePlanDataMutation as deMutation } from "@/modules/patients/services/de/deSaveCarePlanDataMutation"

const useSaveCarePlanDataMutation = () => {
  const country = useCountryParam()

  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutationWithErrorDialog<chSaveCarePlanDataMutation & deSaveCarePlanDataMutation>(mutation)

  return useCallback(
    (
      input: De_saveCarePlanDataInput & Ch_saveCarePlanDataInput,
      onCompleted?: (res: chSaveCarePlanDataMutation$data & deSaveCarePlanDataMutation$data) => void,
    ) =>
      new Promise<chSaveCarePlanDataMutation$data & deSaveCarePlanDataMutation$data>((resolve, reject) => {
        const carePlanSummaryConnectionId = ConnectionHandler.getConnectionID(
          input.progressNoteId,
          "ProgressNoteConnection_carePlanSummary",
        )

        commit({
          variables: {
            input,
            connections: [carePlanSummaryConnectionId],
          },
          onCompleted(response) {
            onCompleted?.(response)
            resolve(response)
          },
          onError(error) {
            reject(error)
          },
        })
      }),
    [commit],
  )
}

export { useSaveCarePlanDataMutation }
